export default "__VITE_ASSET__XYk9LeWK__"